module.exports = __webpack_public_path__ + "img/no-msg.5adc890e.png";